import { CLOSE_EVENTS, OPEN_EVENTS, WS_DATA_EVENT } from '../constants/event.constants';

export const updateEvent = (event) => ({type: WS_DATA_EVENT, data: event });
export const closeEvents = (events) => ({ type: CLOSE_EVENTS, events});
export const openEvents = (events) => ({ type: OPEN_EVENTS, events});